(function () {
  // --- fixed per-bottle prices (from your sheet) ---
  var SUB_PER = { 1: 53.99, 3: 49.49, 6: 44.95 };
  var OTP_PER = { 1: 71.99, 3: 62.99, 6: 58.49 };
  var CMP_PER = { 1: 89.99, 3: 89.99, 6: 89.99 };

  // exact bundle totals for the one product page with full-price mode
  // these are used only when #show-full-bundle-price exists
  var SUB_TOTAL = { 1: 53.99, 3: 148.48, 6: 269.97 };
  var OTP_TOTAL = { 1: 71.99, 3: 188.98, 6: 350.97 };
  var CMP_TOTAL = { 1: 89.99, 3: 269.97, 6: 539.94 };

  // per-bundle discount percentages for the orange "Save X%" badges
  var OTP_DISCOUNT = { 1: 20, 3: 30, 6: 35 };

  // Images per Kaching deal block & per bundle quantity
  // Use data-deal-block-id from .kaching-bundles__block
  var DEAL_IMAGES = {
    // Example: Digestive Probiotics deal
    "b44352b6-6d2f-45f0-94f6-548f7b197332": {
      subscribe: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Product_Photo.png?v=1770983942",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/3-month_supply_-_desktop_f4c9292c-8366-423b-8ba6-491441ccfeb0.png?v=1770983944",
        6: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214134544_b6fdb0c3-4af2-4b28-bab9-94b82c414388.png?v=1770983943"
      },
      otp: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Product_Photo_1_6f45e204-f47c-44ff-96e1-91aa12d41899.png?v=1770983943",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/3-month_supply_-_desktop_1_c74035ad-728b-4894-8ce1-b35dabdff011.png?v=1770983943",
        6: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214134544_1_0c242167-e4e2-45f6-bede-5194b80c7823.png?v=1770983943"
      }
    },
    "d423e24f-baa3-4525-a14e-b7a89b987bec": { // ppv1b
      subscribe: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Product_Photo.png?v=1770983942",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/3-month_supply_-_desktop_f4c9292c-8366-423b-8ba6-491441ccfeb0.png?v=1770983944",
        6: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214134544_b6fdb0c3-4af2-4b28-bab9-94b82c414388.png?v=1770983943"
      },
      otp: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Product_Photo_1_6f45e204-f47c-44ff-96e1-91aa12d41899.png?v=1770983943",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/3-month_supply_-_desktop_1_c74035ad-728b-4894-8ce1-b35dabdff011.png?v=1770983943",
        6: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214134544_1_0c242167-e4e2-45f6-bede-5194b80c7823.png?v=1770983943"
      }
    },

    // Example: Anti-stress product deal (different block id, different images)
    "fd4fb6c7-ef7b-4327-9f39-5b03d5ff38e1": {
      subscribe: { //original
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Product_Photo_2_a3c6a481-dbde-4d6b-9596-d19b634c570c.png?v=1770983943",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/3-month_supply_-_desktop_2_f0c59b92-f82c-4fb5-abbe-71fb25db6714.png?v=1770983943",
        6: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214134545_f91cc584-08d3-42d4-a9bc-f8fe832624af.png?v=1770983943"
      },
      otp: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Product_Photo_3_766578f6-6d9d-45a5-b919-b6fa8566e80f.png?v=1770983943",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/3-month_supply_-_desktop_e18918fa-7654-402b-baa3-f38a8fbe4db3.png?v=1782824264",
        6: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214134545_cd6669d4-b401-403d-902a-5f7b69f73d9c.png?v=1782824266"
      }
    },
    "25640621-a2fe-4d10-b6e5-c7b810fbefc2": {
      subscribe: { // ppv1b
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Product_Photo_2_a3c6a481-dbde-4d6b-9596-d19b634c570c.png?v=1770983943",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/3-month_supply_-_desktop_2_f0c59b92-f82c-4fb5-abbe-71fb25db6714.png?v=1770983943",
        6: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214134545_f91cc584-08d3-42d4-a9bc-f8fe832624af.png?v=1770983943"
      },
      otp: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Product_Photo_3_766578f6-6d9d-45a5-b919-b6fa8566e80f.png?v=1770983943",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/3-month_supply_-_desktop_3_edaa6947-1669-44ab-93fb-edb6e8fe6f10.png?v=1770983943",
        6: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214134545_1_070b28c2-50e8-4e2f-9056-c302cff836ef.png?v=1770983943"
      }
    },
    "ea63a860-4124-4dc4-bfd9-b3f47153c3f4": {
      subscribe: { // ppv1c
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Product_Photo_2_a3c6a481-dbde-4d6b-9596-d19b634c570c.png?v=1770983943",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/3-month_supply_-_desktop_1_c29677cc-16db-45a7-84c0-72a9ab9ed7e7.png?v=1775208690",
        6: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214134545_1_0e13b056-867b-4e2c-aee3-e357b3bd909f.png?v=1775208691"
      },
      otp: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Product_Photo_3_766578f6-6d9d-45a5-b919-b6fa8566e80f.png?v=1770983943",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/3-month_supply_-_desktop_3_edaa6947-1669-44ab-93fb-edb6e8fe6f10.png?v=1770983943",
        6: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214134545_1_070b28c2-50e8-4e2f-9056-c302cff836ef.png?v=1770983943"
      }
    },
    "d444737e-7825-4b7c-b5a1-f0082f713c78": {
      subscribe: { // ppv1a
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135388_2_8237dc8b-4b53-4e98-9b27-504ef9f83c51.png?v=1774506263",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135388_d74e810f-db17-4c2f-ae7a-fb81ba774259.png?v=1774506263",
        6: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135388_1_63ee8b3b-5bd1-4bee-9a50-3d3f2c31163a.png?v=1774506263"
      },
      otp: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135388_2_8237dc8b-4b53-4e98-9b27-504ef9f83c51.png?v=1774506263",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135388_3.png?v=1774506263",
        6: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135388_4.png?v=1774506264"
      }
    },
     "3583afd4-2f7b-46fa-a5ae-47521ec6d0be": {
      subscribe: { // 6 reasons why
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/fd5cb34c5626116d4facb558ff3f351db275a1d6.png?v=1779871721",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135388_1_9de9c162-d5b0-494b-b452-cf9df0ff229b.png?v=1779871711",
        6: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135388_2_4c631d40-2fff-4e07-8fe7-72e6198a9694.png?v=1779871708"
      },
      otp: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/fd5cb34c5626116d4facb558ff3f351db275a1d6.png?v=1779871721",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135388_3_3ffae492-8b71-442e-9e66-100cdf46747a.png?v=1779871704",
        6: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135388_4_5d932a81-7f93-40c8-b234-13665675de1a.png?v=1779871701"
      }
    },
         "5937cb70-cc8b-4a9a-a78e-3f6b65ef9ee7": {
      subscribe: { // pdpv5 gummies
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391_3_4268f098-317b-40a7-b68d-d3903013b31e.png?v=1785410228",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391.png?v=1785407633",
      },
      otp: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391_1_2d912cc7-d48f-4f6c-b3aa-f52e055d9376.png?v=1785407875",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135391_2.png?v=1785409814",
      }
    },
             "0b57a7de-a0e0-4979-b109-a9e88070a980": {
      subscribe: { // pdpv5 gummies
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391_3_4268f098-317b-40a7-b68d-d3903013b31e.png?v=1785410228",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391.png?v=1785407633",
      },
      otp: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391_1_2d912cc7-d48f-4f6c-b3aa-f52e055d9376.png?v=1785407875",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135391_2.png?v=1785409814",
      }
    },
                 "a1fc356e-23dd-4a44-b648-92442dd63e8f": {
      subscribe: { // gummies 6 reasons why
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391_3_4268f098-317b-40a7-b68d-d3903013b31e.png?v=1785410228",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391.png?v=1785407633",
      },
      otp: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391_1_2d912cc7-d48f-4f6c-b3aa-f52e055d9376.png?v=1785407875",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135391_2.png?v=1785409814",
      }
    },
                   "594691fe-f9ff-47ca-9db5-e1f47d35ef5b": {
      subscribe: { // gummies 6 reasons why genz
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391_3_4268f098-317b-40a7-b68d-d3903013b31e.png?v=1785410228",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391.png?v=1785407633",
      },
      otp: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391_1_2d912cc7-d48f-4f6c-b3aa-f52e055d9376.png?v=1785407875",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135391_2.png?v=1785409814",
      }
    },
                  "2ed694af-9bb7-4817-80ba-3fed6f1e007c": {
      subscribe: { // gummies 6 reasons why glp1
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391_3_4268f098-317b-40a7-b68d-d3903013b31e.png?v=1785410228",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391.png?v=1785407633",
      },
      otp: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391_1_2d912cc7-d48f-4f6c-b3aa-f52e055d9376.png?v=1785407875",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135391_2.png?v=1785409814",
      }
    },
                   "2d3155d0-77a3-47ef-868b-22d70ebc18e8": {
      subscribe: { // gummies pdpv6 glp1
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391_3_4268f098-317b-40a7-b68d-d3903013b31e.png?v=1785410228",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391.png?v=1785407633",
      },
      otp: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391_1_2d912cc7-d48f-4f6c-b3aa-f52e055d9376.png?v=1785407875",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135391_2.png?v=1785409814",
      }
    },
                       "56f27d0a-25ec-4eb3-a007-36612b83d63d": {
      subscribe: { // gummies pdpv5 first sub
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391_3_4268f098-317b-40a7-b68d-d3903013b31e.png?v=1785410228",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391.png?v=1785407633",
      },
      otp: {
        1: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Kaching-Bundles-Frame_1214135391_1_2d912cc7-d48f-4f6c-b3aa-f52e055d9376.png?v=1785407875",
        3: "https://cdn.shopify.com/s/files/1/0922/3864/3575/files/Frame_1214135391_2.png?v=1785409814",
      }
    }
  };

  function shouldShowFullBundlePrice() {
    return !!document.getElementById('show-full-bundle-price');
  }

  function getCurrency(root) {
    var el = root.querySelector('.kaching-bundles__bar-price');
    if (!el) return '$';
    var text = (el.textContent || '').trim();
    var m = text.match(/^([^\d-]+)/);
    return (m && m[1]) ? m[1] : '$';
  }

  function getBottlesFromBar(bar) {
    var titleEl = bar.querySelector('.kaching-bundles__bar-title');
    if (!titleEl) return null;
    var text = titleEl.textContent || '';
    var m = text.match(/(\d+)/);
    if (!m) return null;
    var n = parseInt(m[1], 10);
    return isNaN(n) ? null : n;
  }

  function formatMoney(cur, val) {
    return cur + val.toFixed(2);
  }

  function isOtpSelected(root) {
    var subsBars = root.querySelectorAll('.kaching-bundles__subscriptions .kaching-bundles__bar');
    if (!subsBars.length) return false;
    var otpBar = subsBars[subsBars.length - 1];
    return otpBar.classList.contains('kaching-bundles__bar--selected');
  }

  function getSelectedQty(root) {
    var selected = root.querySelector(
      '.kaching-bundles__bars.kaching-bundles__bars--horizontal .kaching-bundles__bar--selected'
    );
    if (!selected) return null;
    return getBottlesFromBar(selected);
  }

  function cleanup(root) {
    root.querySelectorAll('.kb-picker-price').forEach(function (el) {
      el.remove();
    });

    var topBars = root.querySelectorAll(
      '.kaching-bundles__bars.kaching-bundles__bars--horizontal .kaching-bundles__bar'
    );

    topBars.forEach(function (bar) {
      var fulls = bar.querySelectorAll('.kaching-bundles__bar-full-price');
      fulls.forEach(function (fullEl, index) {
        if (index > 0) {
          fullEl.remove();
        }
      });
    });
  }

  function updateTopBars(root, cur) {
    var otp = isOtpSelected(root);

    var bars = root.querySelectorAll(
      '.kaching-bundles__bars.kaching-bundles__bars--horizontal .kaching-bundles__bar'
    );

    bars.forEach(function (bar) {
      var qty = getBottlesFromBar(bar);
      if (!qty || !(qty in SUB_PER)) return;

      var pricing = bar.querySelector('.kaching-bundles__bar-pricing');
      if (!pricing) return;

      var priceEl = pricing.querySelector('.kaching-bundles__bar-price');
      var fullEl = pricing.querySelector('.kaching-bundles__bar-full-price');
      if (!priceEl) return;

      if (!fullEl) {
        fullEl = document.createElement('div');
        fullEl.className = 'kaching-bundles__bar-full-price';
        pricing.appendChild(fullEl);
      }

      var mainPrice, comparePrice;

      if (shouldShowFullBundlePrice()) {
        mainPrice = otp ? OTP_TOTAL[qty] : SUB_TOTAL[qty];
        comparePrice = CMP_TOTAL[qty];
      } else {
        mainPrice = otp ? OTP_PER[qty] : SUB_PER[qty];
        comparePrice = CMP_PER[qty];
      }

      priceEl.textContent = formatMoney(cur, mainPrice);
      fullEl.textContent = formatMoney(cur, comparePrice);
    });
  }

  function setPickerCard(contentEl, cur, mainPer, cmpPer) {
    if (!contentEl) return;

    var wrap = document.createElement('div');
    wrap.className = 'kb-picker-price';

    var mainSpan = document.createElement('span');
    mainSpan.className = 'kb-picker-main';
    mainSpan.textContent = formatMoney(cur, mainPer);
    wrap.appendChild(mainSpan);

    var cmpSpan = document.createElement('span');
    cmpSpan.className = 'kb-picker-compare';
    cmpSpan.style.marginLeft = '8px';
    cmpSpan.style.textDecoration = 'line-through';
    cmpSpan.textContent = formatMoney(cur, cmpPer);
    wrap.appendChild(cmpSpan);

    contentEl.appendChild(wrap);
  }

  function updatePicker(root, cur) {
    var qty = getSelectedQty(root);
    if (!qty || !(qty in SUB_PER)) return;

    var subContent = root.querySelector(
      '.kaching-bundles__subscriptions .kaching-bundles__bar:first-child .kaching-bundles__bar-content'
    );
    var otpContent = root.querySelector(
      '.kaching-bundles__subscriptions .kaching-bundles__bar:last-child .kaching-bundles__bar-content'
    );

    if (shouldShowFullBundlePrice()) {
      var subMain = SUB_TOTAL[qty];
      var otpMain = OTP_TOTAL[qty];
      var cmpMain = CMP_TOTAL[qty];

      setPickerCard(subContent, cur, subMain, cmpMain);
      setPickerCard(otpContent, cur, otpMain, cmpMain);
    } else {
      var subPer = SUB_PER[qty];
      var otpPer = OTP_PER[qty];
      var cmpPer = CMP_PER[qty];

      setPickerCard(subContent, cur, subPer, cmpPer);
      setPickerCard(otpContent, cur, otpPer, cmpPer);
    }
  }

  function updateBadges(root) {
    var otpSelected = isOtpSelected(root);

    var bars = root.querySelectorAll(
      '.kaching-bundles__bars.kaching-bundles__bars--horizontal .kaching-bundles__bar'
    );

    bars.forEach(function (bar) {
      var subtitle = bar.querySelector('.kaching-bundles__bar-subtitle');
      if (!subtitle) return;

      if (!bar.hasAttribute('data-orig-subtitle')) {
        bar.setAttribute('data-orig-subtitle', (subtitle.textContent || '').trim());
      }

      var qty = getBottlesFromBar(bar);

      if (otpSelected && qty && OTP_DISCOUNT[qty]) {
        subtitle.textContent = 'Save ' + OTP_DISCOUNT[qty] + '%';
      } else {
        var orig = bar.getAttribute('data-orig-subtitle');
        if (orig) subtitle.textContent = orig;
      }
    });
  }

  function updateSubscribeBadge(root) {
    var qty = getSelectedQty(root);
    if (!qty || !(qty in SUB_PER) || !(qty in CMP_PER)) return;

    var subPrice = SUB_PER[qty];
    var cmpPrice = CMP_PER[qty];
    var discount = Math.round((1 - subPrice / cmpPrice) * 100);

    var left = root.querySelector(
      '.kaching-bundles__subscriptions .kaching-bundles__bar:first-child .kaching-bundles__bar-content-left'
    );
    if (!left) return;

    var firstLine = left.querySelector('.kaching-bundles__bar-first-line');
    if (!firstLine) return;

    var badge = left.querySelector('.kb-sub-save-badge');
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'kb-sub-save-badge';
      firstLine.insertAdjacentElement('afterend', badge);
    }

    badge.textContent = 'Save ' + discount + '%';
  }

  function enhanceSubscribeBenefits(root) {
    var left = root.querySelector(
      '.kaching-bundles__subscriptions .kaching-bundles__bar:first-child .kaching-bundles__bar-content-left'
    );
    if (!left) return;

    if (left.getAttribute('data-kb-benefits') === '1') return;
    left.setAttribute('data-kb-benefits', '1');

    var subtitle = left.querySelector('.kaching-bundles__subscriptions__subtitle');
    if (!subtitle) return;

    var text = (subtitle.textContent || '').trim();
    var parts = text.split('|').map(function (t) {
      return t.trim();
    }).filter(Boolean);

    subtitle.style.display = 'none';

    if (parts.length) {
      var ul = document.createElement('ul');
      ul.className = 'kb-sub-benefits';

      parts.forEach(function (label) {
        var li = document.createElement('li');
        li.textContent = label;
        ul.appendChild(li);
      });

      left.appendChild(ul);
    }
  }

  function updateTopBarImages(root) {
    var blockId = root.getAttribute("data-deal-block-id");
    if (!blockId) return;

    var cfg = DEAL_IMAGES[blockId];
    if (!cfg) return;

    var otp = isOtpSelected(root);
    var mode = otp ? "otp" : "subscribe";

    var bars = root.querySelectorAll('.kaching-bundles__bars--horizontal .kaching-bundles__bar');
    bars.forEach(function (bar) {
      var img = bar.querySelector('.kaching-bundles__bar-image');
      var title = bar.querySelector('.kaching-bundles__bar-title');
      if (!img || !title) return;

      var match = title.textContent.trim().match(/^(\d+)/);
      if (!match) return;

      var count = match[1];

      if (!bar.dataset.origSubImg) {
        bar.dataset.origSubImg = img.src;
      }

      var newSrc = cfg[mode][count] || bar.dataset.origSubImg;
      img.src = newSrc;
    });
  }

  function recalc(root) {
    if (!root) return;

    function runOnce() {
      cleanup(root);

      var cur = getCurrency(root);
      updateTopBars(root, cur);
      updatePicker(root, cur);
      updateBadges(root);
      updateSubscribeBadge(root);
      enhanceSubscribeBenefits(root);
      updateTopBarImages(root);

      root.classList.remove('kb-switching');
    }

    runOnce();
    setTimeout(runOnce, 120);
    setTimeout(runOnce, 300);
    setTimeout(runOnce, 600);
  }

  function initWhenReady() {
    var attempts = 0;
    var maxAttempts = 60;

    function tick() {
      var root = document.querySelector('.kaching-bundles__block');
      if (root) {
        recalc(root);

        root.addEventListener('click', function () {
          root.classList.add('kb-switching');
          recalc(root);
        });

        return;
      }

      if (attempts++ < maxAttempts) {
        setTimeout(tick, 250);
      }
    }

    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }
})();